import axios from 'axios';
import { backAPI } from '../constant/constants';

const userGetOrders = backAPI.userGetOrders;
const userAddOrder = backAPI.userAddOrder;
const userCancelOrder = backAPI.userCancelOrder;
const adminGetAllOrders = backAPI.adminGetAllOrders;
const adminHandleOrder = backAPI.adminHandleOrder;

const auth_header = () => ({
	authorization: 'Bearer ' + window.localStorage.getItem('token'),
});

const getOrderService = async () => {
	return await axios.get(userGetOrders, {
		//return await axios.get(adminGetArchivedOrders, {
		headers: auth_header(),
	});
};

const addOrderService = async (addressId) => {
	return await axios.post(
		userAddOrder,
		{ addressId },
		{
			headers: auth_header(),
		}
	);
};

const cancelOrderService = async (orderId) =>
	//return await axios.delete(URL, {
	await axios.post(
		userCancelOrder,
		{ orderId, newStatus: 'canceled' },
		{ headers: auth_header() }
	);

const getAllOrderService = async () => {
	return await axios.get(adminGetAllOrders, {
		headers: auth_header(),
	});
};

const adminUpdateOrderService = async (orderId, newStatus) => {
	//return await axios.put(URL,
	return await axios.post(
		adminHandleOrder,
		{ orderId, newStatus },
		{ headers: auth_header() }
	);
};

const orderService = {
	getOrderService,
	addOrderService,
	cancelOrderService,
	getAllOrderService,
	adminUpdateOrderService,
};

export default orderService;
